/**
 * Maps grill SKUs to their corresponding insulated jacket SKUs.
 * Grills not in this map (e.g., 50" hybrids, electric) are simply skipped -- no jacket needed.
 */
export const grillJacketSkuMap: Record<string, string> = {
	'C3C30': 'C3JAKTCSL30',
	'C3SL30': 'C3JAKTCSL30',
	'C3C34': 'CJAKTCC3',
	'C2C34': 'CJAKTCC3',
	'C3CL36': 'CJAKTCS36',
	'C3SL36': 'CJAKTCS36',
	'C3CH36': 'CJAKTCS36',
	'C2C36': 'CJAKTCS36',
	'C2SL36': 'CJAKTCS36',
	'C1CH36': 'CJAKTCS36',
	'CCX4LE': 'CJAKTCS36',
	'C3CL42': 'CJAKTCS42',
	'C3SL42': 'CJAKTCS42',
	'C2C42': 'CJAKTCS42',
	'C2SL42': 'CJAKTCS42',
	'C1C28': 'CJAKTCC2',
	'C2SL30': 'CJAKTCS30',
	'C3FTG30': 'C3JAKTFT',
	'C1FTG30': 'C3JAKTFT',
	'C3PB': 'CJAKTC1PB',
	'C1PB': 'CJAKTC1PB',
	'C3SB': 'CJAKTC1SB',
	'C1SB': 'CJAKTC1SB',
	'C3DB': 'CJAKTC1DB',
	'C1DB': 'CJAKTC1DB',
	'C2P28': 'CJAKTC1P28',
	'C1P28': 'CJAKTC1P28',
	'C2P36': 'CJAKTC1P36',
	'C1P36': 'CJAKTC1P36',
};
